import React from 'react';
import logo from './Logo.svg';

const Logo = () => {
	return (
		<img style={{ height: 45, width: 60}} alt='Logo' src={logo}/> 				
	);
}

export default Logo;